"use strict";
window.addEventListener("load", function () { return initScroll(); });
function initScroll() {
    var _a;
    var url = new URL(window.location.href);
    var params = new URLSearchParams(url.search);
    var collectionPath = url.pathname;
    var sectionApi = "?section_id=collection_cards";
    var path = collectionPath.concat(sectionApi);
    //let pagination = document.querySelector<HTMLElement>(".pagination");
    window.pageNumber = parseInt((_a = params.get('page')) !== null && _a !== void 0 ? _a : "1");
    //let timeout: number = null;
    var paginationContainer = dq(".pagination");
    if (!paginationContainer) {
        return;
    }
    var _b = paginationContainer.dataset, totalItems = _b.totalItems, itemsPerPage = _b.itemsPerPage;
    var debouncedScrollExecute = debounce(function () { return ScrollExecute(path, parseInt(totalItems), parseInt(itemsPerPage)); }, 400);
    window.addEventListener("scroll", debouncedScrollExecute, { passive: true });
}
function debounce(func, wait) {
    var timeout;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var context = this;
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            func.apply(context, args);
        }, wait);
    };
}
function ScrollExecute(path, totalItems, itemsPerPage) {
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    var mainContent = dq(".main-content");
    var paginationNode = dq(".pagination");
    var loadingCards = getById("loading_cards");
    var collectionGrid = getById("collection_cards");
    var renderedItems = itemsPerPage * window.pageNumber;
    var nextPage = window.pageNumber + 1;
    if (window.scrollY + windowHeight >= mainContent.offsetHeight * 0.5) {
        if (renderedItems >= totalItems) {
            loadingCards.classList.add('hide');
            //unbind scroll event with attribute
            paginationNode.toggleAttribute("disabled");
        }
        else if (!paginationNode.hasAttribute("disabled")) {
            loadingCards.classList.remove('hide');
            var scrollUrl = path + "&page=" + nextPage;
            console.log("execute lazy load :)", scrollUrl);
            window.pageNumber++;
            var xhr_1 = new XMLHttpRequest();
            xhr_1.open("GET", scrollUrl);
            xhr_1.onload = function () {
                if (xhr_1.status === 200) {
                    var temp = document.createElement("div");
                    temp.innerHTML = xhr_1.response;
                    var filteredData = temp.querySelectorAll("#collection_cards > div");
                    console.log("filtuuur data", filteredData);
                    //@ts-ignore
                    window.temp = temp;
                    filteredData.forEach(function (item) {
                        collectionGrid.appendChild(item);
                    });
                    loadingCards.classList.add('hide');
                }
            };
            xhr_1.send();
        }
    }
}
var active = 0;
function toggleContent() {
    var sectionHeaderText = document.querySelector(".section-header__subtext");
    var readMoreContent = document.querySelector(".custom-read-more-content");
    var readMoreStatus = document.querySelector(".read-more-status");
    if (sectionHeaderText && readMoreContent && readMoreStatus) {
        sectionHeaderText.classList.toggle("content-hidden");
        readMoreContent.classList.toggle("hidecustom-read-more-content");
        active += 1;
        if (active % 2) {
            readMoreStatus.textContent = "less";
        }
        else {
            readMoreStatus.textContent = "more";
        }
    }
}
(function () {
    var customReadMoreContent = document.querySelector(".custom-read-more-content");
    if (customReadMoreContent) {
        customReadMoreContent.addEventListener("click", toggleContent);
    }
})();
